// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"c5d29717","339":"2be5e5a2","375":"74498609","399":"4ad60b69","453":"51bc4206","529":"009add72","551":"e22a5110","629":"242df2cd","640":"b736c935","672":"d750b5f1","800":"04803b32","842":"1f3cfcde"}[chunkId] + ".chunk.js";
};